import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Select from "react-select";
import { Button, Col, Container, Form, Input, Label, Row } from "reactstrap";
import { getFilteredCourses } from "../../store/actions/HolesAction";
import { getStates } from "../../store/actions/statesCitiesAction";
import SpinnerIcon from "../global/SpinnerIcon";

function SearchFilter({ SearchCourseNameFilter }) {
  const { courses, quickSearch, courseLoader } = useSelector(
    (state) => state.course
  );

  const { countries, states } = useSelector((state) => state.citiesStates);

  const dispatch = useDispatch();
  const param = useParams();

  const initialFilter = {
    name: "",
    country: "",
    state: "",
    city: "",
    limit: 25,
    offset: 0,
  };
  const [filter, setFilter] = useState(initialFilter);

  const areAllFieldsEmpty = () => {
    return (
      !filter.name?.trim() && !filter.state?.trim() && !filter.city?.trim()
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      getFilteredCourses(filter, (data) => {
        SearchCourseNameFilter(data);
      })
    );
  };

  useEffect(() => {
    if (courses.length > 0) {
      SearchCourseNameFilter(courses);
    } else {
      // setFilter(initialFilter);
      SearchCourseNameFilter("");
    }
  }, [courses]);
  useEffect(() => {
    if (Object.keys(quickSearch).length !== 0) {
      setFilter(quickSearch);
    }
  }, [quickSearch]);
  return (
    <>
      <Container className="px-4 px-lg-0 py-5 bg-transparent">
        <Row className="mx-0">
          <h1>Golf Courses {param?.state ? `in ${param?.state}` : ""}</h1>
        </Row>
        <Form className="" onSubmit={handleSubmit}>
          <Row className="align-items-center my-4 mx-0">
            <Label className="sub-form-label">Golf Course</Label>
            <Input
              id="CourseName"
              name="CourseName"
              placeholder=""
              type="text"
              className="signIn__input"
              value={filter.name}
              onChange={(e) =>
                setFilter({
                  ...filter,
                  name: e.target.value,
                })
              }
            />
          </Row>
          <Row className="align-items-center my-4 form-stack">
            <Col xl={4}>
              <Label className="sub-form-label">Country</Label>
              <Select
                isClearable={true}
                className="signIn__input"
                placeholder="Worldwide"
                isSearchable={true}
                name="select"
                options={countries.map((item) => {
                  return {
                    value: item?.code,
                    label: item?.country,
                  };
                })}
                onChange={(selectedOption) => {
                  setFilter((pre) => ({
                    ...pre,
                    country: selectedOption?.value,
                  }));
                  dispatch(getStates(selectedOption?.value, () => {}));
                }}
              />
            </Col>
            <Col xl={4}>
              <Label className="sub-form-label">
                State / Province / Region
              </Label>
              <Select
                isClearable={true}
                isDisabled={!filter.country}
                className="signIn__input"
                placeholder={filter.country ? "All" : "Choose Country"}
                isSearchable={true}
                name="select"
                options={states.map((item) => {
                  return {
                    value: item?.abbreviation,
                    label: item?.state,
                  };
                })}
                onChange={(selectedOption) =>
                  setFilter((pre) => ({
                    ...pre,
                    state: selectedOption?.value,
                  }))
                }
              />
            </Col>
            <Col xl={4}>
              <Label className="sub-form-label">City</Label>
              <Input
                id="city"
                name="city"
                placeholder="Type here"
                type="text"
                className="signIn__input"
                value={filter.city}
                onChange={(e) =>
                  setFilter((pre) => ({
                    ...pre,
                    city: e.target.value,
                  }))
                }
              />
            </Col>
          </Row>
          <Row className="align-items-center my-4">
            <Button
              disabled={courseLoader || areAllFieldsEmpty()}
              type="submit"
              className="text-dark rounded btn btn-site-bgGreen shadow border-0 py-2 px-4 ml-3"
            >
              {courseLoader ? <SpinnerIcon /> : "Submit"}
            </Button>
          </Row>
        </Form>
      </Container>
    </>
  );
}

export default SearchFilter;
